import React from 'react';
import Icon from '../../../components/AppIcon';

const STEPS = [
  { key: 'draft', label: 'Create', icon: 'FilePlus', hint: 'Add payroll records' },
  { key: 'reviewed', label: 'Review', icon: 'Search', hint: 'Validate & mark reviewed' },
  { key: 'approved', label: 'Approve', icon: 'CheckCircle', hint: 'Manager approval' },
  { key: 'locked', label: 'Lock & Pay', icon: 'Lock', hint: 'Process & publish payslips' },
];

export default function PayrollWorkflowBanner({ counts = {} }) {
  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-foreground">Payroll Workflow</h3>
        <span className="text-xs text-muted-foreground">Draft → Review → Approve → Lock</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {STEPS.map((step, idx) => (
          <div key={step.key} className="relative flex items-start gap-3 p-3 rounded-lg bg-muted/40 border border-border">
            {idx < STEPS.length - 1 && (
              <span className="hidden md:block absolute top-1/2 -right-2 w-4 h-px bg-border" />
            )}
            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name={step.icon} size={16} className="text-primary" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">{step.label}</p>
              <p className="text-xs text-muted-foreground">{step.hint}</p>
              <p className="text-lg font-semibold text-foreground mt-1">{counts[step.key] ?? 0}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
